import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";
import { formatDate } from "../../../helpers/dateFormatter";

export const LoanRepaymentDetailsTable: React.FC<BaseTablePropsType> = ({ rows }) => {
    const loanRepaymentDetailsTableHeaders = ["Date", "Principal Amount", "Interest", "Penalty", "Total Amount"];

    return (
        <BaseTable headers={loanRepaymentDetailsTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{formatDate(row?.dueDate, false)}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.principal ?? 0)}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.interest ?? 0)}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.penalty ?? 0)}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.amount ?? 0)}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
